export function checkIsNotStringIdentity(firstString?: string, secondString?: string): boolean {
  if (!firstString || !secondString) return false;

  return firstString.toLowerCase() !== secondString.toLowerCase();
}
